import { motion } from 'framer-motion';
import { Calendar, X } from 'lucide-react';
import { useState } from 'react';
import { Link } from 'react-router-dom';

export function FloatingCTA() {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  return (
    <motion.div
      initial={{ y: 100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      className="fixed bottom-8 right-8 z-50"
    >
      <div className="bg-white rounded-lg shadow-lg p-4 flex items-center gap-4">
        <button
          onClick={() => setIsVisible(false)}
          className="absolute -top-2 -right-2 bg-gray-200 rounded-full p-1 hover:bg-gray-300"
        >
          <X className="h-4 w-4" />
        </button>
        <Link
          to="/contact"
          className="bg-blue-600 text-white px-6 py-3 rounded-md font-semibold hover:bg-blue-700 transition-colors flex items-center gap-2"
        >
          <Calendar className="h-5 w-5" />
          Schedule Appointment
        </Link>
      </div>
    </motion.div>
  );
}